module.exports = __webpack_public_path__ + "static/media/Blonde-in-luxury-interior-343621.c0bce719.jpg";